import React from 'react';
import CircleAvatar from './CircleAvatar';
import { useTranslation } from 'react-i18next';

function renderDescription(description) {
    if (!description) return null;
    // Ссылки: http(s)://, www., telegram username (@username), переносы строк
    const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)|(\@[a-zA-Z0-9_]{4,})/g;
    const parts = description.split(/(https?:\/\/[^\s]+|www\.[^\s]+|\@[a-zA-Z0-9_]{4,})/g);
    return (
        <div className="whitespace-pre-line text-sm text-gray-700 dark:text-gray-300 mt-1">
            {parts.map((part, i) => {
                if (!part) return null;
                if (part.match(/^https?:\/\//) || part.match(/^www\./)) {
                    const url = part.startsWith('http') ? part : `https://${part}`;
                    return <a key={i} href={url} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline break-all">{part}</a>;
                }
                if (part.match(/^\@[a-zA-Z0-9_]{4,}$/)) {
                    // Telegram username
                    return <a key={i} href={`https://t.me/${part.slice(1)}`} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">{part}</a>;
                }
                return part;
            })}
        </div>
    );
}

const ChannelInfo = ({ title, description = '', size = 'normal', showStatistic = true, subscribersCount = 0, postcardsCount = 0, onAvatarClick }) => {
    const { t } = useTranslation();
    const titleSize = size === 'large' ? 'text-xl' : 'text-base';
    const statistic = `${t("UI.ChannelInfo.subscribers", { count: subscribersCount })} · ${t('UI.ChannelInfo.postcards', { count: postcardsCount })}`;

    return (
        <div className="flex items-center gap-2">
            <CircleAvatar name={title} size={size} onClick={onAvatarClick} />
            <div className="flex flex-col pl-1">
                <h2 className={`font-semibold ${titleSize}`}>{title}</h2>
                {showStatistic && <p className="text-sm text-gray-500 dark:text-gray-400">{statistic}</p>}
                {renderDescription(description)}
            </div>
        </div>
    );
};

export default ChannelInfo;
